
import { client } from ".";
export const fetchUserById = async (userId, accessToken) => {
    try {
        const user = await client.get(`/api/user/user/get/${userId}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        return user.data;
    } catch (error) {
        console.error(error);
    }
}